import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { TranslateModule } from '@ngx-translate/core';
import { MapAppsData } from '@sc/data-access-models';
import { IconComponent } from '@sc/ui-components';
import { MapAppsComponent } from '../../components/map-apps/map-apps.component';

@Component({
  selector: 'sc-map-app-bottom-sheet-container',
  styleUrls: ['./map-app-bottom-sheet.container.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, MapAppsComponent, TranslateModule],
  template: `
    <div class="header">
      <span>{{ 'MapAppBottomSheet.howToGetIn' | translate }}</span>
      <button type="button" class="close-btn" (click)="onCancel()">
        <sc-icon name="close"></sc-icon>
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate: { dialogTitle: 'MapApps.dialogTitle' | translate }
        }}</span>
      </button>
    </div>

    <h1 mat-dialog-title class="sr_only" id="map-app-bottom-sheet-title-id">
      {{ 'MapApps.dialogTitle' | translate }}
    </h1>

    <sc-map-apps
      [userAddress]="data.userAddress"
      [fitter]="data.fitter"
    ></sc-map-apps>
  `,
})
export class MapAppBottomSheetContainer {
  constructor(
    public bottomSheetRef: MatBottomSheetRef<MapAppBottomSheetContainer>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: MapAppsData
  ) {}

  onCancel(): void {
    this.bottomSheetRef.dismiss();
  }
}
